import axios from "axios";

export default class CxmApiClient {
  constructor(User, AuthorizationHeader) {
    this.scope =
      User && User.ViewSelectedStores
        ? User.ViewSelectedStores.map(store => store.AccountPlatformID)
        : [];
    this.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: AuthorizationHeader
    };
  }

  formatRequestUrl(requestUrl) {
    if (requestUrl && !requestUrl.startsWith("/"))
      requestUrl = `/${requestUrl}`;

    return process.env.PANDO_CXM_API_URL + requestUrl;
  }

  ProcessRequest(type, url, payload, scope, params, responseType) {
    this.headers.Scope = JSON.stringify(
      scope && scope.length > 0 ? scope : this.scope
    );
    return axios({
      method: type,
      url: this.formatRequestUrl(url),
      params: params,
      data: payload,
      headers: this.headers,
      responseType: responseType || "json"
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/CxmApiClient.js